import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';

import SavedCards from './SavedCards';
import Reviews from './review';
import ExamCodes from './FillExamCodes';
import Message1 from './FillProgramId';
import Semesters from './FillSemesters';
import ScrutinyDetails from './ScrutinyDetails';
import MonthYr from './FillMonthyr';
import ExamType from './FillExamType';
import BundleNo from './FillBundleNo';
import ScruValuationType from './FillvalType'
import OmrCodes from './OmrCodes';
import Message from './MarkSaving';
import MarksTable from './MarksTable';
import GrandtotalMarks from './CheckTotalMarks';
import scriptPath from './ScriptPdf';
import ProgramId from './FillProgramId';
import tokenMessage from './UserTokenRegister';
import AdmintokenMessage from './AdminToken';
import CrystalPdf from './CrystalPdf';
import IpAddress from './ValuatorLoginSaving';
import AdminProgram from './AdminFillprogram';
import AdminData from './Admindetails';
import AdminExamtype from'./AdminFillexamtype';
import AdminSem from './AdminFillsem';
import AdminMonthYr from './AdminFillMonth';
import AdminExamCodes from './AdminFillexamcodes';
import AdminBundleNo from './AdminFillBundleNo';
import AdminOmrCodes from './AdminOmrcodes';
import AdminMarksTable from './AdminMarksTable';
import scrutinyapprove from './Scrutinyapprove';
import AutoSave from './MarkSaving';
import Ipadress1 from './ValuatorLoginSaving';
import BundleMessage from './ScruBundlestatus';
import Bundlestatus from './ScruBundlestatus';
import AdminBundleMessage from './Adminbundlestatus';
import AdminBundleStatus from './Adminbundlestatus';
import AdminValuationType from './AdminValtype.js';
import FeedbackMessage from './ScrutinyFeedback'
export default (history) => combineReducers({
  router: connectRouter(history),
  savedCards: SavedCards,
  Reviews :Reviews,
  ExamCodes: ExamCodes,
  Message1:Message1,
  ExamType:ExamType,
  Semesters:Semesters,
  MonthYr:MonthYr,
  ScrutinyDetails:ScrutinyDetails,
  ProgramId:ProgramId,
  ExamType:ExamType,
  AdminExamtype:AdminExamtype,
  AdminSem:AdminSem,
  AdminMonthYr:AdminMonthYr,
  AdminMarksTable:AdminMarksTable,
  BundleNo:BundleNo,
  ScruValuationType:ScruValuationType,
  OmrCodes:OmrCodes,
  MarksTable:MarksTable,
  Message:Message,
  GrandtotalMarks:GrandtotalMarks,
  scriptPath:scriptPath,
  AdminProgram:AdminProgram,
  AdminData:AdminData,
  AdminExamCodes:AdminExamCodes,
  AdminBundleNo:AdminBundleNo,
  AdminOmrCodes:AdminOmrCodes,
  tokenMessage:tokenMessage,
  CrystalPdf:CrystalPdf,
  IpAddress:IpAddress,
  scrutinyapprove:scrutinyapprove,
   AutoSave:AutoSave,
    Ipadress1:Ipadress1,
    BundleMessage:BundleMessage,
    AdminBundleMessage:AdminBundleMessage,
    AdminValuationType:AdminValuationType,
    Bundlestatus:Bundlestatus,
    AdminBundleStatus:AdminBundleStatus,
    AdmintokenMessage:AdmintokenMessage,
    FeedbackMessage:FeedbackMessage
});
